import axios from "axios";

const apiUrl = () => {

  const processEnv = process.env;
  console.log('processEnv:');
  console.log(processEnv);
  console.log(processEnv.REACT_APP_API_URL);

  var url = "";
  switch (true) {
    case window.location.href.includes("localhost:3000"):
    case window.location.href.includes("localhost:3001"):
    case window.location.href.includes("localhost:3004"):
      //url = "https://trade-multimarque-backend--stg.pierre-fabre.dev/api/";
      url = "http://127.0.0.1:8000/api/";
      break;
    case window.location.href.includes(
      "https://trade-multimarque-frontend--stg.pierre-fabre.dev"
    ):
      url = "https://trade-multimarque-backend--stg.pierre-fabre.dev/api/";
      break;
    case window.location.href.includes("https://trade.pierre-fabre.com"):
      url = "https://trade-backend.pierre-fabre.com/api/";
      break;
    case window.location.href.includes("https://production-vohbr3y-4bmo73yhv6o52.eu-5.platformsh.site"):
      url = processEnv.REACT_APP_API_URL;
      break;
    default:
      throw new Error("Cannot detect corresponding API");
  }

  return url;
};

const request = async (data, url, method) => {
  var headers = "";

  /*
  if (localStorage.getItem("token")) {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
  } else {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }

  const pending = await axios({
    headers,
    method,
    //credentials: false,
    url: apiUrl() + url,
    data,
    //maxContentLength: Infinity,
    //maxBodyLength: Infinity,
    //timeout: 0,
  });
  */


 if (localStorage.getItem("token")) {
  headers = {
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  //headers["Authorization"] = "Bearer " + localStorage.getItem("token");
  }

// 🛑 MODIFICATION CLÉ ICI : Gérer l'en-tête Content-Type
// Si les données NE SONT PAS de type FormData, on force Content-Type: application/json
if (!(data instanceof FormData)) {

  headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  /*
  headers["Content-Type"] = "application/json";
  headers["Accept"] = "application/json";
  */
} else {
  // Si c'est FormData, Axios/le navigateur DOIT définir le Content-Type: multipart/form-data
  // Nous ne devons RIEN ajouter ici concernant Content-Type
  //headers["Accept"] = "application/json"; // Garder Accept si vous attendez du JSON en retour

  headers = {
    Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
}

// Note: Si vous aviez un cas où les données sont FormData MAIS vous utilisez PUT, 
// le champ _method: PUT dans data est suffisant si la méthode Axios est POST.

const pending = await axios({
  headers, // Utilise l'objet headers ajusté
  method,
  //credentials: false,
  url: apiUrl() + url,
  data,
  //maxContentLength: Infinity,
  //maxBodyLength: Infinity,
  //timeout: 0,
});


  const response = pending;

  return response.data;
};

const requestBlobFile = async (data, url, method) => {
  var headers = "";

  if (localStorage.getItem("token")) {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
  } else {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }

  const pending = await axios({
    headers,
    method,
    url: apiUrl() + url,
    data,
    responseType: "blob",
  });

  const response = pending;

  return response.data;
};

const requestXls = async (data, url, method) => {
  var headers = "";

  if (localStorage.getItem("token")) {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
  } else {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }

  const pending = await axios({
    headers,
    method,
    url: apiUrl() + url,
    data,
    responseType: "blob",
  });

  const response = pending;

  return response.data;
};

const getApiBaseUrl = () => {
  // Logique copiée de votre ApiService.js (sans le /api/ final)
  var url = "";
  const currentHref = window.location.href;

  switch (true) {
      case currentHref.includes("localhost:3000"):
      case currentHref.includes("localhost:3001"):
      case currentHref.includes("localhost:3004"):
          // Base URL pour le local (le port 8000 du backend Laravel)
          url = "http://127.0.0.1:8000"; 
          break;
      case currentHref.includes("https://trade-multimarque-frontend--stg.pierre-fabre.dev"):
          // Base URL pour la staging
          url = "https://trade-multimarque-backend--stg.pierre-fabre.dev";
          break;
      case currentHref.includes("https://trade.pierre-fabre.com"):
          // Base URL pour la production
          url = "https://trade-backend.pierre-fabre.com";
          break;
      default:
          // Peut-être renvoyer une erreur ou la production par défaut
          throw new Error("Cannot detect corresponding API base URL");
  }

  return url;
};

// Fonction pour construire l'URL d'affichage complète
export const getImageFullUrl = (relativePath) => {
  if (!relativePath) return null;
  
  // Si l'image est déjà une URL complète (parfois le cas si renvoyée par l'API)
  if (relativePath.startsWith('http')) {
      return relativePath;
  }
  
  // Construction de l'URL : Base URL + /storage + Chemin de la BDD
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}/storage/${relativePath}`;
};

const ApiService = {
  apiUrl,
  request,
  requestXls,
  requestBlobFile,
  getImageFullUrl
};
export default ApiService;